import { ColDef } from 'ag-grid-community';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import React, { memo, useMemo } from 'react';
import { EM_DASH } from '../../Base.constants';

import './AGTable.scss';

export interface TableProps<TData> extends AgGridReactProps<TData> {
  additionalDefaultColDef?: ColDef<TData>;
}
const AGTable = <TData,>({ additionalDefaultColDef, ...props }: TableProps<TData>) => {
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      editable: false,
      minWidth: 100,
      valueFormatter: (params) => params.value ?? EM_DASH,
      ...additionalDefaultColDef,
    }),
    [additionalDefaultColDef]
  );
  return (
    <div className="ag-theme-alpine" data-testid="table">
      <AgGridReact
        headerHeight={40}
        rowHeight={33}
        suppressRowHoverHighlight
        suppressCellFocus
        defaultColDef={defaultColDef}
        suppressMultiSort
        suppressDragLeaveHidesColumns
        className="ag-table"
        unSortIcon
        maintainColumnOrder
        {...props}
      />
    </div>
  );
};

export default memo(AGTable) as typeof AGTable;
